module.exports = __webpack_public_path__ + "img/BlinkArt_Shield_Epic.553d045f.png";